import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import type { components } from 'api/playerPayback/api'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronReferralProgressForBadge = ({
  patronId,
  badgeRewardId,
}: {
  patronId: number
  badgeRewardId: number
}): UseQueryResult<Array<components['schemas']['QualifyingReferralDTO']>> => {
  const get = useTypedApiClient({
    path: '/admin/patronbadgerewards/{badgeRewardId}/qualifying-referrals',
    method: 'get',
  })

  return useQuery({
    queryKey: [
      '/admin/patronbadgerewards/{badgeRewardId}/qualifying-referrals',
      patronId,
      badgeRewardId,
    ],
    queryFn: async () => {
      const { data } = await get({ patronId, badgeRewardId })
      return data
    },
  })
}
